import React from "react";
import { ArrowRight, Car, Lock } from "lucide-react";
import { Link } from "react-router-dom";
import { CONTACT, IMAGES } from "@/config";
import { Script } from "@/components/Script";

type AdminAuthFrameProps = {
  eyebrow: string;
  title: string;
  description: string;
  children: React.ReactNode;
};

export const AdminAuthFrame: React.FC<AdminAuthFrameProps> = ({ eyebrow, title, description, children }) => (
  <div className="flex min-h-screen flex-col bg-gradient-to-b from-blue-50/60 to-white">
    <header className="border-b border-slate-100 bg-white/90 backdrop-blur">
      <div className="container-x flex h-[72px] items-center justify-between">
        <Link to="/" className="flex items-center gap-3 leading-tight">
          <img src={IMAGES.brandLogo} alt="" className="h-11 w-11 rounded-xl object-contain" width="44" height="44" />
          <div>
            <div className="text-xl font-extrabold text-slate-900">Simphiwe <span className="text-red-600">Fudwana</span></div>
            <div className="text-[11px] font-medium text-slate-500">{CONTACT.role}</div>
          </div>
        </Link>
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-500 hover:text-blue-600">
          <Car className="h-4 w-4" /> Back to Website <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </header>

    <main className="container-x flex flex-1 items-center justify-center py-10">
      <section className="w-full max-w-lg">
        <div className="mb-7 text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold text-slate-600">
            <Lock className="h-3.5 w-3.5" /> {eyebrow}
          </span>
          <h1 className="mt-4 text-3xl font-extrabold text-slate-900 sm:text-4xl">{title}</h1>
          <p className="mx-auto mt-3 max-w-md text-sm text-slate-500">{description}</p>
        </div>
        <div className="card-soft p-6 sm:p-8">{children}</div>
      </section>
    </main>

    <footer className="border-t border-slate-100 bg-white py-6">
      <div className="container-x flex flex-col items-center justify-between gap-3 text-xs text-slate-400 sm:flex-row">
        <span>© 2026 Simphiwe Fudwana. All rights reserved.</span>
        <Script size="text-xl">Good People, Great Journeys</Script>
      </div>
    </footer>
  </div>
);
